import { render, staticRenderFns } from "./LostGlobal.vue?vue&type=template&id=19a1f154"
import script from "./LostGlobal.vue?vue&type=script&lang=js"
export * from "./LostGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports